"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ENV_KEY = void 0;
const ENV_KEY = exports.ENV_KEY = {
  USE_RELATE_PATH: 'USE_RELATE_PATH',
  PROTOCOL: 'PROTOCOL',
  INTERNET_HOST: 'INTERNET_HOST',
  PORT: 'PORT',
  CONTEXT_ROOT: 'CONTEXT_ROOT',
  CONTEXT_DL_ROOT: 'CONTEXT_DL_ROOT',
  CONTEXT_API_ROOT: 'CONTEXT_API_ROOT',
  GROUPHISAI_EMAIL: 'GROUPHISAI_EMAIL',
  GOOGLE_KEY: 'GOOGLE_KEY',
  AZURE_TENANT_ID: 'AZURE_TENANT_ID',
  AZURE_CLIENT_ID: 'AZURE_CLIENT_ID',
  FRONT_PROTOCOL: 'FRONT_PROTOCOL',
  FRONT_HOST: 'FRONT_HOST',
  FRONT_PORT: 'FRONT_PORT'
};
const getEnv = key => {
  if (!key) {
    return null;
  }
  if (typeof ENV === 'undefined') {
    return null;
  }

  // eslint-disable-next-line no-undef
  return ENV[key];
};
const isStaging = () => {
  let contextRoot = getEnv(ENV_KEY.CONTEXT_ROOT);
  if (!contextRoot) {
    return false;
  }
  return contextRoot.endsWith('_staging');
};
const isHyoka = () => {
  let host = getEnv(ENV_KEY.INTERNET_HOST);
  if (!host) {
    return false;
  }
  return host.startsWith('hyoka.');
};
var _default = exports.default = Object.freeze({
  getEnv,
  isStaging,
  isHyoka
});